import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { getSpecificBucket } from '../../../../../utils/bucket';
import { useSelector } from 'react-redux';
import { API, LocalAPI } from '../../../../../constants/baseurl';
import { servicesManager } from '../../../../../platform/app/src/App';

const UploadPDF = ({ onClose, tableData, index }) => {
  const { StudyInstanceUIDs } = tableData[index];
  const { uiNotificationService } = servicesManager.services;
  const folderName = useSelector(state => state.user.selectedFolder);
  const modalRef = useRef(null);
  const [files, setFiles] = useState([]);

  // Close modal if clicked outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Handle file selection
  const handleFileChange = event => {
    const selectedFiles = Array.from(event.target.files).filter(
      file => file.type === 'application/pdf'
    );
    setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
  };

  // Handle file drop
  const handleDrop = event => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files).filter(
      file => file.type === 'application/pdf'
    );
    setFiles(prevFiles => [...prevFiles, ...droppedFiles]);
  };

  const handleUpload = async () => {
    const token = localStorage.getItem('token');
    const bucketId = localStorage.getItem('bucketId');
    const bucket = await getSpecificBucket(bucketId);
    const path =
      folderName == ''
        ? StudyInstanceUIDs
        : 'FolderStructure/' + folderName + '/' + StudyInstanceUIDs;

    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    formData.append('bucketName', bucket.bucketName);
    formData.append('AwsAccessKey', bucket.accessKeyId);
    formData.append('AwsSecretAccessKey', bucket.secretAccessKey);
    formData.append('path', path);
    try {
      const response = await axios.post(`${LocalAPI}/apilocal/v1/local/cloudUploadPDF`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status == 200) {
        uiNotificationService.show({
          title: 'Upload PDF',
          message: 'PDF has been uploaded successfully.',
          type: 'success',
          duration: 3000,
        });
        onClose();
      }
    } catch (error) {
      uiNotificationService.show({
        title: 'Upload PDF',
        message: 'PDF failed to upload.',
        type: 'error',
        duration: 3000,
      });
      console.log(error);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        ref={modalRef}
        className="dark:bg-primary-modalgray w-full max-w-md rounded-lg bg-white p-6 shadow-lg"
        onDragOver={e => e.preventDefault()}
        onDrop={handleDrop}
      >
        <div className="flex flex-col items-center space-y-4">
          {/* File Drop Area */}
          <label className="flex w-full cursor-pointer flex-col items-center rounded-lg border-2 border-dashed border-gray-300 p-6">
            <input
              type="file"
              accept=".pdf"
              multiple
              className="hidden"
              onChange={handleFileChange}
            />
            <svg
              className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Drop your .pdf files here or click to select.
            </p>
          </label>

          {/* File Count */}
          <p className="text-xs text-gray-500 dark:text-gray-400">Files: {files.length}</p>

          {/* Buttons */}
          <div className="flex w-full justify-end space-x-2">
            <button
              className="bg-primary-light hover:bg-primary-gray dark:hover:bg-primary-newgray rounded-md px-4 py-2 text-sm text-white transition-colors duration-200"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="bg-primary-light hover:bg-primary-gray dark:hover:bg-primary-newgray rounded-md px-3 py-2 text-sm text-white transition-colors duration-200"
              onClick={handleUpload}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadPDF;
